import { makeAutoObservable } from "mobx";

export type LoadingType = "noStart" | "loading" | "error" | "success";

class mixCutPreviw {
  private data: any[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  public getData() {
    return this.data;
  }

  public setData(data: any[]) {
    this.data = data;
  }
}

const MixCutPreviw = new mixCutPreviw();

export default MixCutPreviw;
